import React from 'react';
import { useDispatch } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { isNull, isUndefined } from 'lodash';

import { RightCol } from '@components/HealthQuoteBuyRoute/right-col';
import HealthQuoteBuyCustomForm, { FormValues } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyCustomForm';
import { Loading, LoadingError } from '@components/Base';

import { useCancerQuoteFetch } from '../hook';
import { cancerQuoteCustom, CancerQuoteCustomPayload } from '../action';
import { useInitialValues } from './hook';

const CancerQuoteBuyCustomPage = () => {
  const dispatch = useDispatch();
  const cancerQuote = useCancerQuoteFetch();
  const initialValues = useInitialValues();

  if (isUndefined(cancerQuote)) return <Loading />;
  if (isNull(cancerQuote)) return <LoadingError />;
  if (!initialValues) return null;

  const { cancerPlanName, orderNumber } = cancerQuote;

  const handleSubmit = (values: FormValues) => {
    const payload: CancerQuoteCustomPayload = { ...values, orderNumber };
    dispatch(cancerQuoteCustom(payload));
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <HealthQuoteBuyCustomForm initialValues={initialValues} onSubmit={handleSubmit} />
        </Col>

        <RightCol {...cancerQuote} planName={cancerPlanName} />
      </Row>
    </Container>
  );
};

export { CancerQuoteBuyCustomPage };
